import { wrapActions, wrapSelector, wrapSelectorWithArg } from 'store/utils';

import * as actions from './actions';
import { getChapters, getChapter } from './selectors';

export const useTasksActions = wrapActions({ ...actions });

export const useChapters = wrapSelector(getChapters);
export const useChapter = wrapSelectorWithArg(getChapter);
